import React, {useEffect, useState} from "react";
import {configStaffAreas} from "../../../config/configStaffAreas";
import {configStaffAreasOutreach} from "../../../config/configStaffAreasOutreach";
import FunctionsData from "../../../Functions/FunctionsData";
import {configStaffAreasInspectors} from "../../../config/configStaffAreasInspectors";

export default function CampaignsSelectCampaignArea({row}) {

	const [val,setVal] = useState('');

	useEffect(() => {
		setVal(row.hub_ad_id);
	}, [row]);

	function updateItem(e) {
		const d = e.target.value;
		FunctionsData.postData(
			FunctionsData.getApiUrl('/api/campaign/')+row.id,
			{hub_ad_id:d}
		).then((r) => {
			setVal(d);
		})
	}

	if(row.campaign_target === 'public') return null;

	// console.log(configStaffAreasInspectors.sort(function (a, b) {return a - b;}))
	if (row.campaign_target === 'inspectors') {
  return (
    <div style={{ marginTop: 20, minWidth: 200 }}>
      <h5>Area / HUB / Center</h5>
      <select className="form-control" value={val} onChange={updateItem}>
        <option value="">Please specify...</option>
        {configStaffAreasInspectors
          .sort((a, b) => a - b)
          .map((area) => (
            <option key={area.id} value={area.id}>
              {area.displayName}
            </option>
          ))}
      </select>
    </div>
  );
}

if (row.campaign_target === 'outreach') {
  return (
    <div style={{ marginTop: 20, minWidth: 200 }}>
      <h5>Center</h5>
      <select
        className="form-control"
        value={val}
        onChange={updateItem}
        style={{ borderColor: val === '' ? 'red' : 'green' }}
      >
        <option value="">Please specify...</option>
        {configStaffAreasOutreach
          .sort((a, b) => a - b)
          .map((area) => (
            <option key={area.id} value={area.id}>
              {area.displayName}
            </option>
          ))}
      </select>
    </div>
  );
}

// default case (when campaign_target is neither 'inspectors' nor 'outreach')
return (
  <div style={{ marginTop: 20, minWidth: 200 }}>
    <h5>Center</h5>
    <select
      className="form-control"
      value={val}
      onChange={updateItem}
      style={{ borderColor: val === '' ? 'red' : 'green' }}
    >
      <option value="">Please specify...</option>
      {configStaffAreas
        .sort((a, b) => a - b)
        .map((area) => (
          <option key={area.id} value={area.id}>
            {area.displayName}
          </option>
        ))}
    </select>
  </div>
);

}
